'use client';

import React, { useState } from 'react';
import { registerToCourse } from '@/app/courses/actions';
import {usePathname, useRouter, useSearchParams} from 'next/navigation';
import { useSession } from 'next-auth/react';
import {MetaEntity} from "@/types/meta";
import {CourseEntity} from "@/types/course";
import {CalculateFinalPrice} from "@/components/text/price.lib";
import {getWalletTempIRT} from "@/app/(dashboard)/dashboard/wallet/actions";
import MaterialButton from "@/components/ui/buttons/global/MaterialButton";
import {chargeWalletIRT} from "@/app/(dashboard)/dashboard/actions";
import PaymentModal from "@/components/pages/modal/PaymentModal";

const CourseRegisterButton = ({ meta }: { meta: MetaEntity }) => {

  const course = meta.data as CourseEntity;
  const router = useRouter();
  const pathname = usePathname();

  const queryParameters = new URLSearchParams(useSearchParams().toString());
  queryParameters.set('callback', meta.slug);
  const linkToSignIn = `/signIn${queryParameters.size ? '?' + queryParameters.toString() : ''}`;


  const {data: session} = useSession();
  const [loadingStates, setLoadingState] = useState<{
    registerToCourse?: boolean;
    showChargeWalletDialog?: boolean;
    // currencies?: {
    //   fiat: CurrencyFiatI[],
    //   crypto: CurrencyCryptoI[],
    // }
  }>({});
  const [payDialog, setPayDialog] = useState<{
    isOpen: boolean;
    discountCode?: string;
    walletValue?: number;
    coursePrice?: number;
  }>({ isOpen: false });


  const registerToCourseButtonHandle = async () => {

    if(!session?.token){
      return router.replace(linkToSignIn);
    }

    setLoadingState(prevState => {
      return {
        ...prevState,
        registerToCourse: true
      };
    });

    // calculate course price
    const { finalPrice, priceWithDiscount } = CalculateFinalPrice(course);

    console.log('finalPrice', finalPrice, 'priceWithDiscount', priceWithDiscount);

    // return;

    // register for free
    if (finalPrice === 0
      || (priceWithDiscount !== undefined && priceWithDiscount <= 0)
      || (course.limitFreeUsage && course.registeredMembers && course.limitFreeUsage > course?.registeredMembers)
    ) {
      await registerToCourse({ courseId: course._id! })
        .then(value => {
          if (value?.success === true) {
            router.refresh();
          }
        });
    }

    // const currencies = loadingStates.currencies ?? await getCurrencyPrices();
    // const wallet = await getBalances({ currencies });
    const wallet: number = payDialog.walletValue ?? await getWalletTempIRT().then(walletValue => {
      // set New State
      setPayDialog(prevState => {
        return { ...prevState, walletValue }
      })

      return walletValue;
    });

    // register via Wallet
    if(finalPrice <= wallet){
      await registerToCourse({ courseId: course._id! })
          .then(value => {
            if (value?.success === true) {
              router.refresh();
            }
          });

      setLoadingState(prevState => {
        return {
          ...prevState,
          registerToCourse: false
        };
      });
      return;
    }

    setPayDialog(prevState => {
      return {
        ...prevState,
        isOpen: true,
        coursePrice: (priceWithDiscount ? priceWithDiscount : finalPrice) - wallet,
      }
    });

    // const balance = wallet?.balances.find(({ currency }) => currency === course.price.baseCurrency);
    // if (balance?.amount) {
    //   if (balance.amount >= finalPrice) {
    //     await registerToCourse({ courseId: course._id! })
    //       .then(value => {
    //         if (value?.success === true) {
    //           router.refresh();
    //         }
    //       });
    //
    //     setLoadingState(prevState => {
    //       return {
    //         ...prevState,
    //         registerToCourse: false
    //       };
    //     });
    //     return;
    //   }
    // }

    setLoadingState(prevState => {
      return {
        ...prevState,
        registerToCourse: false,
        showChargeWalletDialog: true,
        // currencies
      };
    });


    // if (course.price === 0 || course.priceDiscount === 0) {
    //   if (!session) {
    //     setShowAlertDialog({
    //       title: 'You are not logged in!',
    //       description: 'Please sign up and start learning',
    //       buttonText: 'Register',
    //       imageUrl: '/images/login.jpg',
    //       onClose: () => setShowAlertDialog(undefined),
    //       onPressOnYes: () => router.replace('/auth/signin')
    //     });
    //     return;
    //   }
    //   registerToCourseRequest(course).then((res: { success: boolean; courseMember?: CourseMemberInterface }) => {
    //     console.log(res);
    //     if (res?.success) {
    //       setCourseMember(res?.courseMember);
    //     }
    //   }).finally(() => setLoadingState(prevState => {
    //     return {
    //       ...prevState,
    //       registerToCourse: false
    //     };
    //   })).catch(reason => {
    //     console.log(reason);
    //   });
    // }

  };

  const gatewayPayment = ({code, amount}: {
    code: string | undefined;
    amount: number | undefined;
  }) => {


    const finalPrice = Math.max(payDialog.coursePrice! - payDialog.coursePrice! * (amount ?? 0), 0);
    if(code){

      if(finalPrice <= (payDialog.walletValue ?? 0)){
        return registerToCourse({
          courseId: course._id!,
          discountCode: code,
        })
            .then(value => {
              if (value?.success === true) {
                router.refresh();
              }
            });
      }

    }

    chargeWalletIRT({
      amount: Math.abs((payDialog.coursePrice ?? course.price.value ?? 100000) - (payDialog.walletValue ?? 0)),
      callbackUrl: pathname,
      purchaseFor: 'Course',
      purchaseForId: (meta.data as CourseEntity)._id,
      discountCode: code,
    }).then(value => {

      console.log(value)
      if(value?.success){
        window.open(value.link, '_blank', 'noopener,noreferrer');
      }
    }).finally(() => {
      // setDialogState(prevState => {
      //   return { ...prevState, loading: false };
      // });
    })
  };
  return (
    <>
      <MaterialButton
          text={'ثبت نام'}
        loading={loadingStates.registerToCourse}
        className={'w-full sm:w-auto px-4 lg:w-full'}
        onClick={() => registerToCourseButtonHandle()}>
      </MaterialButton>


      <div>
        <PaymentModal
            isOpen={payDialog.isOpen}
            onClose={() => setPayDialog(prevState => {
              return {
                ...prevState,
                isOpen: false
              };
            })}
            onPay={(code, amount) => {
              gatewayPayment({ code, amount })
            }}
            course={course}
        />
      </div>

      {/*{loadingStates.showChargeWalletDialog && <WalletAddCreditDialog*/}
      {/*  currencies={loadingStates.currencies!}*/}
      {/*  onClose={() => setLoadingState(prevState => {*/}
      {/*    return {*/}
      {/*      ...prevState,*/}
      {/*      showChargeWalletDialog: undefined*/}
      {/*    };*/}
      {/*  })} />*/}
      {/*}*/}
    </>
  );
};

export default CourseRegisterButton;
